module.exports = __webpack_public_path__ + "img/login-bg-11.68488db8.jpg";